//https://github.com/moroshko/react-autosuggest


// server.autosuggest.js
import React from 'react';
import useEffect from 'react';
import Autosuggest from 'react-autosuggest';
import '../autocomplete/autocomplete.css';

class ComuneAutoSuggest extends React.Component {
    constructor(props) {
        super(props);
        //Define state for value and suggestion collection
        this.state = {
            value: this.props.inputText,
            suggestions: [],
            suggestion: {}
        };
    }

    // Filter logic
    getSuggestions = async (value) => {
        const inputValue = value.trim().toLowerCase();

        //let response = await fetch("https://api.umbriaenergy.it/api/datasets/comuni?qs="+inputValue);
        let response = await fetch(process.env.REACT_APP_API_URL + "datasets/comuni?qs=" + inputValue);
        let data = await response.json()
        return data;
    };

    // Trigger suggestions
    getSuggestionValue = suggestion => suggestion.com_des;

    // Render Each Option
    renderSuggestion = suggestion => (
        <span className="sugg-option">
            <span className="name">
                {suggestion.com_des} ({suggestion.pro_sigla})
            </span>
        </span>
    );
    // OnChange event handler
    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    // OnBlur event handler
    onBlur = (event) => {
        //console.log(this.state.value);
        //console.log(this.state.suggestion);
        if (this.state.value.trim().length != 0) {
            if ((this.state.suggestion.com_des == null) || (this.state.suggestion.com_des == undefined)) {
                this.setState({
                    value: ""
                });
            } else {
                this.setState({
                    value: this.state.suggestion.com_des
                });
            }
        }
    };

    // Suggestion rerender when user types
    onSuggestionsFetchRequested = ({ value }) => {
        this.getSuggestions(value)
            .then(data => {
                if (data.Error) {
                    this.setState({
                        suggestions: []
                    });
                } else {
                    this.setState({
                        suggestions: data
                    });

                }
            })
    };

    // Triggered on clear
    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };


    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        this.props.onSelectValue(suggestion);
        this.setState({
            suggestion: suggestion
        });
    };

    shouldRenderSuggestions = (value) => {
        return value.trim().length > 2;
    }

    render() {
        const { value, suggestions } = this.state;

        // Option props
        const inputProps = {
            placeholder: 'Comune',
            value,
            onChange: this.onChange,
            onBlur: this.onBlur
        };


        // Adding AutoSuggest component
        return (
            <Autosuggest

                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={this.getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                onSuggestionSelected={this.onSuggestionSelected}
                inputProps={inputProps}
                shouldRenderSuggestions={this.shouldRenderSuggestions}
                ref={el => this.input = el}
                value={value}

                highlightFirstSuggestion={true}
                focusInputOnSuggestionClick={true}
            />
        );
    }
}

export default ComuneAutoSuggest;